<template>
  <div class="question-container">
    <!-- PREVIEW MODE -->
    <div v-if="mode == 0">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="isSkippable(question)">Optional</span>
        </div>

        <div class="col-md-7">
          <template v-if="answer && answer.answerText">
            <div v-html="answer[JsonFieldToDisplay()]"></div>
          </template>
        </div>

        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4" v-html="answer.score"></div>
          </div>
        </template>
        <template v-else-if="isSkippable(question)">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4" v-html="question.skipScore || 0"></div>
          </div>
        </template>
      </div>
    </div>

    <!-- EDIT MODE -->
    <div v-else-if="mode == 1">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="isSkippable(question)">Optional</span>
          <span v-if="isQuestionSkipped()" class="skipped-question-box ml-15 d-inline-box pt-2">
            Skipped
          </span>
        </div>
        <div class="col-md-7" :class="isQuestionSkipped() ? 'disable-question' : ''">
          <div v-if="question.direction.toLowerCase() === 'horizontal'">
            <div v-if="surveyData && surveyData.newLayout == true">
              <dsSliderCustomScale
                :ref="`slider-${question.id}`"
                :value="answer && answer.answerText"
                :piecewise="true"
                direction="horizontal"
                class="horizontal-vue-slider pt-20"
                :min="question.minValue"
                :max="question.maxValue"
                :disabled="answer && answer.isDisabled ? true : false"
                :piecewiseLabel="true"
                :data="question.labels"
                :dotSize="answer.isSkipped ? 0 : 10"
                :tooltip="answer.isSkipped ? false : 'always'"
                :clickable="false"
                @drag-start="refreshScale(question.id)"
                @input="onSliderValueChange($event)"
              >
              </dsSliderCustomScale>
            </div>
            <div v-else>
              <ds-slider
                :ref="`slider-${question.id}`"
                :value="answer && answer.answerText"
                :piecewise="true"
                direction="horizontal"
                class="horizontal-vue-slider pt-20"
                :min="question.minValue"
                :max="question.maxValue"
                :disabled="answer && answer.isDisabled ? true : false"
                :piecewiseLabel="true"
                :data="question.labels"
                :dotSize="answer.isSkipped ? 0 : 10"
                :tooltip="answer.isSkipped ? false : 'always'"
                :clickable="false"
                @drag-start="refreshScale(question.id)"
                @input="onSliderValueChange($event)"
              >
              </ds-slider>
            </div>
          </div>

          <div v-else-if="question.direction.toLowerCase() === 'vertical'">
            <ds-slider
              :ref="`slider-${question.id}`"
              :value="answer && answer.answerText"
              :piecewise="true"
              direction="vertical"
              :min="question.minValue"
              :max="question.maxValue"
              :disabled="answer && answer.isDisabled ? true : false"
              :height="300"
              :piecewiseLabel="true"
              :data="question.labels"
              :width="5"
              class="vertical-vue-slider"
              :dotSize="answer.isSkipped ? 0 : 10"
              :tooltip="answer.isSkipped ? false : 'always'"
              :clickable="false"
              @drag-start="refreshScale(question.id)"
              @input="onSliderValueChange($event)"
            >
            </ds-slider>
          </div>
          <span v-if="hasFieldError" class="text-danger">
            <p>{{ fieldErrorText }}</p>
          </span>
          <span v-if="hasFieldWarning" class="text-warning">{{ fieldWarningText }}</span>
        </div>

        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4" v-html="answer.score"></div>
          </div>
        </template>
        <template v-else-if="isSkippable(question)">
          <div class="ml-25 d-inline-block pt-20" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4" v-html="question.skipScore || 0"></div>
          </div>
        </template>
      </div>
    </div>

    <!-- RESPONSE MODE -->
    <div v-else-if="mode == 2">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <div class="row">
            <div class="col-md-12 d-flex p-0 answers">
              <span class="changed" v-if="answer && answer.edit_status == 1"></span>
              <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
              <template v-if="activityType == 'activity'">
                <span class="question-text" v-html="question.formattedBody"></span>
              </template>
              <template v-else>
                <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
                <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
              </template>
              <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="isSkippable(question)">Optional</span>
            </div>
            <!-- CURRENT ANSWER -->
            <template v-if="answer && answer.answer_text">
              <div class="col-md-12 d-flex pl-30">
                <span class="text-align" v-html="selectedLanguageCulture == 'EN' ? answer.answer_text : answer.display_answer_text"></span>
              </div>
              <div class="row">
                <div class="d-inline-block ml-25 pt-10" v-if="showScore && activityType == 'activity' && answer.score != null">
                  <label>Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4" v-html="answer.score"></div>
                </div>
              </div>
            </template>
            <template v-else-if="isSkippable(question)">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4" v-html="question.skipScore || 0"></div>
              </div>
            </template>
          </div>
        </div>
        <div class="col-md-7 previous-answer" v-if="answer && answer.edit_status == 1">
          <div>
            <span class="previous-value-mark"></span>
            <div class="previous-value ml-3">PREVIOUS RESPONSE</div>
            <template v-if="answer && answer.privius_answer_text">
              <div>
                <span class="text-align" v-html="selectedLanguageCulture == 'EN' ? answer.privius_answer_text : answer.privius_display_answer_text"></span>
              </div>
              <div class="row">
                <div class="d-inline-block ml-0 pt-10" v-if="showScore && answer.privius_score != null">
                  <label>Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4" v-html="answer.privius_score"></div>
                </div>
              </div>
            </template>
            <template v-else-if="isSkippable(question)">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4" v-html="question.skipScore || 0"></div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import activityCommonMixin from "./activity-common-mixin";
import dsSlider from "../../../../lib/ds-slider-component";
import dsSliderCustomScale from "../../../../lib/ds-slider-component-custom-scale";

export default {
  name: "CustomScaleResponse",
  mixins: [activityCommonMixin],
  data() {
    return {
      updatedAns: this.answer && this.answer.answerText,
      hasFieldError: false,
      fieldErrorText: "",
      hasFieldWarning: false,
      fieldWarningText: ""
    };
  },
  components: {
    dsSlider,
    dsSliderCustomScale
  },
  props: {
    mode: Number,
    answer: Object,
    surveyData: Object,
    question: Object,
    usage: Object,
    stepIndex: Number,
    selectedLanguageCulture: String,
    activityType: String
  },
  watch: {
    hasFieldError(val) {
      this.question.hasFieldError = val;
    },
    fieldErrorText(val) {
      this.question.fieldErrorText = val;
    }
  },
  methods: {
    isSkippable(question) {
      return question.isSkipped || question.isSkippable;
    },
    refreshScale(questionId) {
      const ref = `slider-${questionId}`;
      this.$nextTick(() => {
        this.$refs[ref].refresh();
      });
    },
    onSliderValueChange(value) {
      if (this.isQuestionSkipped()) {
        return;
      }
      this.updatedAns = value;
      this.checkForFieldErrors();

      if (this.answer && !this.hasFieldError) {
        if (this.question.labels && this.question.labels.length) {
          const labelIndex = this.question.labels.findIndex(i => i == this.updatedAns);
          if (labelIndex != -1 && !!this.question.scores) {
            this.$set(this.answer, "score", this.question.scores[labelIndex]);
          }
        }
        this.$set(this.answer, "computedScore", this.answer.score);
      }

      this.$emit(`answerChanged`, {
        questionId: this.question.id,
        newAns: this.updatedAns
      });
    },
    checkForFieldErrors() {
      this.question.dataChecks = [];

      if (this.question.dataEditChecks) {
        let softDataCheck = false;
        for (let k = 0; k < this.question.dataEditChecks.length; k++) {
          if (this.question.dataEditChecks[k].check == "SOFT") {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK" && this.updatedAns == "") {
              this.question.isSkippable = true;
              softDataCheck = true;
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: `This field is required.`
              });
            }
          } else {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK") {
              this.question.isSkippable = false;
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }

      this.hasFieldError = false;
      this.fieldErrorText = "";
      this.hasFieldWarning = false;
      this.fieldWarningText = "";
      if (!this.isSkippable(this.question) && !!this.updatedAns == false) {
        this.hasFieldError = true;
        this.fieldErrorText = "This field is required.";
      } else if (this.isSkippable(this.question) && !!this.updatedAns == false) {
        this.hasFieldWarning = true;
        this.fieldWarningText = "This field is required.";
      }
    },
    isQuestionSkipped() {
      return this.answer.isSkipped;
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.changed {
  position: absolute;
  left: -29px;
  top: 0;
  width: 18px;
  height: 51px;
  border-radius: 1px;
  background-color: #f5a623;
}

.question-text {
  display: inline;
}

.previous-value-mark {
  width: 9px;
  height: 51px;
  background-color: #f5a623;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.previous-value {
  /* font-family: Roboto; */
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #f5a623;
  margin-bottom: 9px;
  margin-top: 3px;
}

.answers {
  font-weight: 600;
  color: #000000;
}
</style>
